module.exports = __webpack_public_path__ + "media/dance/surfs_up_dude-e3cb826c.mp3";